import type { Tab } from '@logistiek-zonder-papier/lzp-library'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

export function useTabQuery(tabs: Tab[], defaultTab: string) {
  const route = useRoute()
  const router = useRouter()

  return computed<string>({
    get: () => {
      const queryTab = route.query['tab']
      const isKnownTab = typeof queryTab === 'string' && tabs.some(tab => tab.key === queryTab)
      return isKnownTab ? queryTab : defaultTab
    },
    set: tab => {
      void router.replace({
        query: { ...route.query, tab },
      })
    },
  })
}
